function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M428.959 344.356H4.833L216.895 5.054z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  d: "M428.959 344.356v-2.68H9.665l207.23-331.568 209.793 335.669 2.271-1.421v-2.68 2.68l2.272-1.422L216.895 0 0 347.035h433.792l-2.561-4.101z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#009370",
  d: "M363.992 334.789c-.046.518-.456.751-.972.751-.671 0-1.114-.615-1.114-1.434 0-.87.388-1.399 1.092-1.399.464 0 .892.188.994.717h1.045c-.188-1.169-1.002-1.775-2.039-1.775-1.467 0-2.372 1.049-2.372 2.482 0 1.388.948 2.468 2.394 2.468 1.002 0 1.895-.628 2.061-1.81h-1.089zm-5.414-.659c0 2.381 1.938 4.319 4.319 4.319s4.325-1.938 4.325-4.319c0-2.384-1.944-4.324-4.325-4.324s-4.319 1.941-4.319 4.324zm4.319 3.194c-1.753 0-2.975-1.222-2.975-3.193 0-1.975 1.221-3.199 2.975-3.199s2.978 1.225 2.978 3.199c0 1.971-1.225 3.193-2.978 3.193zM367.825 336.776l3.341-2.713c.366-.299 1.058-.993 1.058-1.565 0-.64-.428-1.037-1.058-1.037-.825 0-1.396.708-1.643 1.434l-1.717-.883c.428-1.092 1.597-2.138 3.525-2.138 2.572 0 3.297 1.488 3.297 2.491 0 1.046-.652 1.797-1.51 2.369l-2.273 1.557v.021h3.771v1.983h-6.792v-1.519zM380.437 334.162c0 2.239-.474 2.7-1.187 2.7-.72 0-1.194-.461-1.194-2.7s.474-2.701 1.194-2.701c.713-.001 1.187.461 1.187 2.701zm-4.827 0c0 2.726 1.553 4.288 3.639 4.288 2.083 0 3.636-1.563 3.636-4.288 0-1.729-.892-4.288-3.636-4.288-2.747 0-3.639 2.559-3.639 4.288zM387.207 329.874c2.747 0 3.639 2.56 3.639 4.288 0 2.726-1.556 4.288-3.639 4.288-2.082 0-3.639-1.563-3.639-4.288 0-1.729.892-4.288 3.639-4.288zm0 1.586c-.716 0-1.19.462-1.19 2.701s.474 2.7 1.19 2.7c.717 0 1.19-.461 1.19-2.7s-.473-2.701-1.19-2.701zM391.708 336.776l3.341-2.713c.363-.299 1.058-.993 1.058-1.565 0-.64-.431-1.037-1.058-1.037-.831 0-1.403.708-1.643 1.434l-1.723-.883c.431-1.092 1.6-2.138 3.528-2.138 2.568 0 3.294 1.488 3.294 2.491 0 1.046-.649 1.797-1.507 2.369l-2.27 1.557v.021h3.768v1.983h-6.789v-1.519zM35.441 327.391h362.908L216.895 37.064z"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rating-uc_svg__a",
  d: "M35.441 327.391h362.908L216.895 37.064z"
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "rating-uc_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rating-uc_svg__a",
  overflow: "visible"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M183.451 289.127h8.121v11.984h.099c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.61 8.625 12.883 0 5.765-2.406 13.178-9.229 13.178-3.156 0-5.214-1.501-6.816-3.906l-1.504 3.604h-4.211v-35.688zm8.121 27.623c-.151 2.104 1.104 3.255 2.658 3.255 2.255 0 2.557-2.252 2.557-6.915v-1.907c0-5.015 0-7.616-2.507-7.616-1 0-1.753.603-2.255 1.002l-.452.449v11.732z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M200.554 289.127h8.121v11.984h.099c1.15-1.206 3.259-2.055 4.914-2.055 5.611 0 8.619 5.61 8.619 12.883 0 5.765-2.405 13.178-9.222 13.178-3.161 0-5.215-1.501-6.821-3.906l-1.501 3.604h-4.208v-35.688zm8.121 27.623c-.153 2.104 1.102 3.255 2.656 3.255 2.252 0 2.553-2.252 2.553-6.915v-1.907c0-5.015 0-7.616-2.504-7.616-1.001 0-1.751.603-2.256 1.002l-.449.449v11.732z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M217.877 305.37h-3.304v-5.716h3.304v-2.806c0-6.164 3.058-8.422 8.423-8.422 1.605 0 2.812.153 4.115.301v6.214c-.455-.099-1.058-.196-1.507-.196-2.055 0-2.91.646-2.91 2.153v2.756h4.417v5.716h-4.417v19.446h-8.121V305.37z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M238.789 309.03c0-1.003-.055-2.202-.4-3.156-.406-1.009-1.052-1.704-2.356-1.704-2.713 0-3.008 3.304-3.008 8.317 0 5.667.898 7.519 3.008 7.519 2.854 0 3.107-2.904 3.107-4.812l6.312.904c-.597 6.116-4.109 9.327-10.021 9.327-7.321 0-11.13-6.417-11.13-12.637 0-6.866 3.809-13.731 11.48-13.731 8.625 0 9.923 7.463 9.923 9.973h-6.915z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M242.246 309.048a3.278 3.278 0 013.267 3.272 3.282 3.282 0 01-3.267 3.273 3.28 3.28 0 01-3.273-3.273 3.276 3.276 0 013.273-3.272z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M183.451 247.994h8.121v11.979h.099c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.616 8.625 12.883 0 5.765-2.406 13.184-9.229 13.184-3.156 0-5.214-1.501-6.816-3.913l-1.504 3.618h-4.211v-35.696zm8.121 27.617c-.151 2.11 1.104 3.267 2.658 3.267 2.255 0 2.557-2.264 2.557-6.921v-1.907c0-5.008 0-7.616-2.507-7.616-1 0-1.753.597-2.255 1.003l-.452.449v11.725z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M200.554 247.994h8.121v11.979h.099c1.15-1.206 3.259-2.055 4.914-2.055 5.611 0 8.619 5.616 8.619 12.883 0 5.765-2.405 13.184-9.222 13.184-3.161 0-5.215-1.501-6.821-3.913l-1.501 3.618h-4.208v-35.696zm8.121 27.617c-.153 2.11 1.102 3.267 2.656 3.267 2.252 0 2.553-2.264 2.553-6.921v-1.907c0-5.008 0-7.616-2.504-7.616-1.001 0-1.751.597-2.256 1.003l-.449.449v11.725z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M217.877 264.236h-3.304v-5.716h3.304v-2.806c0-6.164 3.058-8.422 8.423-8.422 1.605 0 2.812.147 4.115.295v6.22c-.455-.104-1.058-.202-1.507-.202-2.055 0-2.91.658-2.91 2.159v2.756h4.417v5.716h-4.417v19.453h-8.121v-19.453z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M238.789 267.89c0-.997-.055-2.203-.4-3.156-.406-.997-1.052-1.704-2.356-1.704-2.713 0-3.008 3.31-3.008 8.324 0 5.66.898 7.523 3.008 7.523 2.854 0 3.107-2.91 3.107-4.823l6.312.904c-.597 6.122-4.109 9.327-10.021 9.327-7.321 0-11.13-6.417-11.13-12.631 0-6.872 3.809-13.737 11.48-13.737 8.625 0 9.923 7.469 9.923 9.973h-6.915z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M242.246 267.909a3.28 3.28 0 013.267 3.279 3.281 3.281 0 01-3.267 3.272 3.276 3.276 0 010-6.551z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M183.451 206.867h8.121v11.978h.099c1.157-1.199 3.261-2.055 4.916-2.055 5.617 0 8.625 5.611 8.625 12.883 0 5.759-2.406 13.178-9.229 13.178-3.156 0-5.214-1.501-6.816-3.906l-1.504 3.605h-4.211v-35.683zm8.121 27.617c-.151 2.104 1.104 3.254 2.658 3.254 2.255 0 2.557-2.258 2.557-6.915v-1.907c0-5.014 0-7.616-2.507-7.616-1 0-1.753.603-2.255 1.003l-.452.449v11.732z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M200.554 206.867h8.121v11.978h.099c1.15-1.199 3.259-2.055 4.914-2.055 5.611 0 8.619 5.611 8.619 12.883 0 5.759-2.405 13.178-9.222 13.178-3.161 0-5.215-1.501-6.821-3.906l-1.501 3.605h-4.208v-35.683zm8.121 27.617c-.153 2.104 1.102 3.254 2.656 3.254 2.252 0 2.553-2.258 2.553-6.915v-1.907c0-5.014 0-7.616-2.504-7.616-1.001 0-1.751.603-2.256 1.003l-.449.449v11.732z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M217.877 223.102h-3.304v-5.709h3.304v-2.806c0-6.165 3.058-8.423 8.423-8.423 1.605 0 2.812.148 4.115.296v6.22c-.455-.104-1.058-.203-1.507-.203-2.055 0-2.91.652-2.91 2.159v2.757h4.417v5.709h-4.417v19.447h-8.121v-19.447z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M238.789 226.762c0-1.003-.055-2.208-.4-3.156-.406-1.002-1.052-1.704-2.356-1.704-2.713 0-3.008 3.304-3.008 8.318 0 5.666.898 7.518 3.008 7.518 2.854 0 3.107-2.903 3.107-4.811l6.312.897c-.597 6.122-4.109 9.327-10.021 9.327-7.321 0-11.13-6.417-11.13-12.63 0-6.866 3.809-13.732 11.48-13.732 8.625 0 9.923 7.463 9.923 9.973h-6.915z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M242.246 226.781a3.279 3.279 0 013.267 3.273 3.281 3.281 0 01-3.267 3.272 3.28 3.28 0 01-3.273-3.272 3.276 3.276 0 013.273-3.273z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M111.258 289.127h8.121v11.984h.099c1.156-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.61 8.622 12.883 0 5.765-2.405 13.178-9.225 13.178-3.156 0-5.214-1.501-6.816-3.906l-1.504 3.604h-4.211v-35.688zm8.121 27.623c-.151 2.104 1.104 3.255 2.658 3.255 2.255 0 2.556-2.252 2.556-6.915v-1.907c0-5.015 0-7.616-2.507-7.616-1 0-1.753.603-2.255 1.002l-.452.449v11.732z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M128.358 289.127h8.124v11.984h.099c1.15-1.206 3.257-2.055 4.913-2.055 5.614 0 8.619 5.61 8.619 12.883 0 5.765-2.406 13.178-9.222 13.178-3.159 0-5.214-1.501-6.82-3.906l-1.504 3.604h-4.208v-35.688zm8.124 27.623c-.154 2.104 1.101 3.255 2.655 3.255 2.255 0 2.556-2.252 2.556-6.915v-1.907c0-5.015 0-7.616-2.507-7.616-1.003 0-1.753.603-2.255 1.002l-.449.449v11.732z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M145.686 305.37h-3.307v-5.716h3.307v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.603 0 2.809.153 4.113.301v6.214c-.452-.099-1.055-.196-1.504-.196-2.058 0-2.91.646-2.91 2.153v2.756h4.414v5.716h-4.414v19.446h-8.121V305.37z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M166.597 309.03c0-1.003-.056-2.202-.403-3.156-.403-1.009-1.052-1.704-2.356-1.704-2.71 0-3.009 3.304-3.009 8.317 0 5.667.901 7.519 3.009 7.519 2.857 0 3.106-2.904 3.106-4.812l6.315.904c-.6 6.116-4.109 9.327-10.025 9.327-7.318 0-11.126-6.417-11.126-12.637 0-6.866 3.809-13.731 11.48-13.731 8.622 0 9.923 7.463 9.923 9.973h-6.914z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M170.052 309.048c1.799 0 3.27 1.47 3.27 3.272a3.282 3.282 0 01-3.27 3.273 3.279 3.279 0 01-3.27-3.273 3.274 3.274 0 013.27-3.272z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M111.258 247.994h8.121v11.979h.099c1.156-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.616 8.622 12.883 0 5.765-2.405 13.184-9.225 13.184-3.156 0-5.214-1.501-6.816-3.913l-1.504 3.618h-4.211v-35.696zm8.121 27.617c-.151 2.11 1.104 3.267 2.658 3.267 2.255 0 2.556-2.264 2.556-6.921v-1.907c0-5.008 0-7.616-2.507-7.616-1 0-1.753.597-2.255 1.003l-.452.449v11.725z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M128.358 247.994h8.124v11.979h.099c1.15-1.206 3.257-2.055 4.913-2.055 5.614 0 8.619 5.616 8.619 12.883 0 5.765-2.406 13.184-9.222 13.184-3.159 0-5.214-1.501-6.82-3.913l-1.504 3.618h-4.208v-35.696zm8.124 27.617c-.154 2.11 1.101 3.267 2.655 3.267 2.255 0 2.556-2.264 2.556-6.921v-1.907c0-5.008 0-7.616-2.507-7.616-1.003 0-1.753.597-2.255 1.003l-.449.449v11.725z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M145.686 264.236h-3.307v-5.716h3.307v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.603 0 2.809.147 4.113.295v6.22c-.452-.104-1.055-.202-1.504-.202-2.058 0-2.91.658-2.91 2.159v2.756h4.414v5.716h-4.414v19.453h-8.121v-19.453z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M166.597 267.89c0-.997-.056-2.203-.403-3.156-.403-.997-1.052-1.704-2.356-1.704-2.71 0-3.009 3.31-3.009 8.324 0 5.66.901 7.523 3.009 7.523 2.857 0 3.106-2.91 3.106-4.823l6.315.904c-.6 6.122-4.109 9.327-10.025 9.327-7.318 0-11.126-6.417-11.126-12.631 0-6.872 3.809-13.737 11.48-13.737 8.622 0 9.923 7.469 9.923 9.973h-6.914z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M170.052 267.909a3.28 3.28 0 013.27 3.279 3.282 3.282 0 01-3.27 3.272 3.275 3.275 0 010-6.551z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M111.258 206.867h8.121v11.978h.099c1.156-1.199 3.261-2.055 4.916-2.055 5.614 0 8.622 5.611 8.622 12.883 0 5.759-2.405 13.178-9.225 13.178-3.156 0-5.214-1.501-6.816-3.906l-1.504 3.605h-4.211v-35.683zm8.121 27.617c-.151 2.104 1.104 3.254 2.658 3.254 2.255 0 2.556-2.258 2.556-6.915v-1.907c0-5.014 0-7.616-2.507-7.616-1 0-1.753.603-2.255 1.003l-.452.449v11.732z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M128.358 206.867h8.124v11.978h.099c1.15-1.199 3.257-2.055 4.913-2.055 5.614 0 8.619 5.611 8.619 12.883 0 5.759-2.406 13.178-9.222 13.178-3.159 0-5.214-1.501-6.82-3.906l-1.504 3.605h-4.208v-35.683zm8.124 27.617c-.154 2.104 1.101 3.254 2.655 3.254 2.255 0 2.556-2.258 2.556-6.915v-1.907c0-5.014 0-7.616-2.507-7.616-1.003 0-1.753.603-2.255 1.003l-.449.449v11.732z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M145.686 223.102h-3.307v-5.709h3.307v-2.806c0-6.165 3.058-8.423 8.422-8.423 1.603 0 2.809.148 4.113.296v6.22c-.452-.104-1.055-.203-1.504-.203-2.058 0-2.91.652-2.91 2.159v2.757h4.414v5.709h-4.414v19.447h-8.121v-19.447z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M166.597 226.762c0-1.003-.056-2.208-.403-3.156-.403-1.002-1.052-1.704-2.356-1.704-2.71 0-3.009 3.304-3.009 8.318 0 5.666.901 7.518 3.009 7.518 2.857 0 3.106-2.903 3.106-4.811l6.315.897c-.6 6.122-4.109 9.327-10.025 9.327-7.318 0-11.126-6.417-11.126-12.63 0-6.866 3.809-13.732 11.48-13.732 8.622 0 9.923 7.463 9.923 9.973h-6.914z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M170.052 226.781a3.28 3.28 0 013.27 3.273 3.282 3.282 0 01-3.27 3.272 3.279 3.279 0 01-3.27-3.272 3.274 3.274 0 013.27-3.273z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M39.065 289.127h8.121v11.984h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.61 8.622 12.883 0 5.765-2.405 13.178-9.225 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.501 3.604h-4.214v-35.688zm8.121 27.623c-.151 2.104 1.104 3.255 2.658 3.255 2.251 0 2.556-2.252 2.556-6.915v-1.907c0-5.015 0-7.616-2.507-7.616-1.002 0-1.753.603-2.254 1.002l-.452.449v11.732z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M56.165 289.127h8.124v11.984h.099c1.15-1.206 3.257-2.055 4.912-2.055 5.614 0 8.619 5.61 8.619 12.883 0 5.765-2.405 13.178-9.222 13.178-3.159 0-5.214-1.501-6.82-3.906l-1.501 3.604h-4.211v-35.688zm8.124 27.623c-.154 2.104 1.101 3.255 2.655 3.255 2.254 0 2.556-2.252 2.556-6.915v-1.907c0-5.015 0-7.616-2.507-7.616-1.006 0-1.757.603-2.255 1.002l-.449.449v11.732z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M73.493 305.37h-3.307v-5.716h3.307v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.605 0 2.809.153 4.11.301v6.214c-.449-.099-1.052-.196-1.501-.196-2.058 0-2.91.646-2.91 2.153v2.756h4.411v5.716h-4.411v19.446h-8.121V305.37z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M94.404 309.03c0-1.003-.056-2.202-.403-3.156-.403-1.009-1.055-1.704-2.356-1.704-2.71 0-3.008 3.304-3.008 8.317 0 5.667.901 7.519 3.008 7.519 2.858 0 3.107-2.904 3.107-4.812l6.315.904c-.6 6.116-4.11 9.327-10.025 9.327-7.318 0-11.126-6.417-11.126-12.637 0-6.866 3.808-13.731 11.48-13.731 8.623 0 9.924 7.463 9.924 9.973h-6.916z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M97.858 309.048c1.8 0 3.27 1.47 3.27 3.272a3.282 3.282 0 01-3.27 3.273 3.279 3.279 0 01-3.27-3.273 3.276 3.276 0 013.27-3.272z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M39.065 247.994h8.121v11.979h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.616 8.622 12.883 0 5.765-2.405 13.184-9.225 13.184-3.156 0-5.211-1.501-6.817-3.913l-1.501 3.618h-4.214v-35.696zm8.121 27.617c-.151 2.11 1.104 3.267 2.658 3.267 2.251 0 2.556-2.264 2.556-6.921v-1.907c0-5.008 0-7.616-2.507-7.616-1.002 0-1.753.597-2.254 1.003l-.452.449v11.725z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M56.165 247.994h8.124v11.979h.099c1.15-1.206 3.257-2.055 4.912-2.055 5.614 0 8.619 5.616 8.619 12.883 0 5.765-2.405 13.184-9.222 13.184-3.159 0-5.214-1.501-6.82-3.913l-1.501 3.618h-4.211v-35.696zm8.124 27.617c-.154 2.11 1.101 3.267 2.655 3.267 2.254 0 2.556-2.264 2.556-6.921v-1.907c0-5.008 0-7.616-2.507-7.616-1.006 0-1.757.597-2.255 1.003l-.449.449v11.725z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M73.493 264.236h-3.307v-5.716h3.307v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.605 0 2.809.147 4.11.295v6.22c-.449-.104-1.052-.202-1.501-.202-2.058 0-2.91.658-2.91 2.159v2.756h4.411v5.716h-4.411v19.453h-8.121v-19.453z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M94.404 267.89c0-.997-.056-2.203-.403-3.156-.403-.997-1.055-1.704-2.356-1.704-2.71 0-3.008 3.31-3.008 8.324 0 5.66.901 7.523 3.008 7.523 2.858 0 3.107-2.91 3.107-4.823l6.315.904c-.6 6.122-4.11 9.327-10.025 9.327-7.318 0-11.126-6.417-11.126-12.631 0-6.872 3.808-13.737 11.48-13.737 8.623 0 9.924 7.469 9.924 9.973h-6.916z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M97.858 267.909c1.8 0 3.27 1.47 3.27 3.279a3.282 3.282 0 01-3.27 3.272 3.276 3.276 0 010-6.551z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M39.065 206.867h8.121v11.978h.098c1.157-1.199 3.261-2.055 4.916-2.055 5.614 0 8.622 5.611 8.622 12.883 0 5.759-2.405 13.178-9.225 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.501 3.605h-4.214v-35.683zm8.121 27.617c-.151 2.104 1.104 3.254 2.658 3.254 2.251 0 2.556-2.258 2.556-6.915v-1.907c0-5.014 0-7.616-2.507-7.616-1.002 0-1.753.603-2.254 1.003l-.452.449v11.732z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M56.165 206.867h8.124v11.978h.099c1.15-1.199 3.257-2.055 4.912-2.055 5.614 0 8.619 5.611 8.619 12.883 0 5.759-2.405 13.178-9.222 13.178-3.159 0-5.214-1.501-6.82-3.906l-1.501 3.605h-4.211v-35.683zm8.124 27.617c-.154 2.104 1.101 3.254 2.655 3.254 2.254 0 2.556-2.258 2.556-6.915v-1.907c0-5.014 0-7.616-2.507-7.616-1.006 0-1.757.603-2.255 1.003l-.449.449v11.732z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M73.493 223.102h-3.307v-5.709h3.307v-2.806c0-6.165 3.058-8.423 8.422-8.423 1.605 0 2.809.148 4.11.296v6.22c-.449-.104-1.052-.203-1.501-.203-2.058 0-2.91.652-2.91 2.159v2.757h4.411v5.709h-4.411v19.447h-8.121v-19.447z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M94.404 226.762c0-1.003-.056-2.208-.403-3.156-.403-1.002-1.055-1.704-2.356-1.704-2.71 0-3.008 3.304-3.008 8.318 0 5.666.901 7.518 3.008 7.518 2.858 0 3.107-2.903 3.107-4.811l6.315.897c-.6 6.122-4.11 9.327-10.025 9.327-7.318 0-11.126-6.417-11.126-12.63 0-6.866 3.808-13.732 11.48-13.732 8.623 0 9.924 7.463 9.924 9.973h-6.916z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M97.858 226.781c1.8 0 3.27 1.471 3.27 3.273a3.282 3.282 0 01-3.27 3.272 3.279 3.279 0 01-3.27-3.272 3.276 3.276 0 013.27-3.273z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M255.646 289.127h8.121v11.984h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.61 8.625 12.883 0 5.765-2.412 13.178-9.228 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.501 3.604h-4.214v-35.688zm8.121 27.623c-.148 2.104 1.101 3.255 2.658 3.255 2.251 0 2.559-2.252 2.559-6.915v-1.907c0-5.015 0-7.616-2.51-7.616-1.003 0-1.754.603-2.258 1.002l-.449.449v11.732z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M272.749 289.127h8.121v11.984h.098c1.15-1.206 3.255-2.055 4.916-2.055 5.61 0 8.619 5.61 8.619 12.883 0 5.765-2.406 13.178-9.222 13.178-3.163 0-5.217-1.501-6.823-3.906l-1.501 3.604h-4.208v-35.688zm8.121 27.623c-.154 2.104 1.101 3.255 2.651 3.255 2.258 0 2.56-2.252 2.56-6.915v-1.907c0-5.015 0-7.616-2.504-7.616-1.009 0-1.76.603-2.258 1.002l-.449.449v11.732z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M290.073 305.37h-3.304v-5.716h3.304v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.606 0 2.805.153 4.11.301v6.214c-.449-.099-1.052-.196-1.501-.196-2.055 0-2.91.646-2.91 2.153v2.756h4.411v5.716h-4.411v19.446h-8.121V305.37z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M310.984 309.03c0-1.003-.055-2.202-.4-3.156-.406-1.009-1.058-1.704-2.362-1.704-2.707 0-3.002 3.304-3.002 8.317 0 5.667.898 7.519 3.002 7.519 2.861 0 3.107-2.904 3.107-4.812l6.318.904c-.597 6.116-4.11 9.327-10.022 9.327-7.321 0-11.129-6.417-11.129-12.637 0-6.866 3.808-13.731 11.48-13.731 8.619 0 9.923 7.463 9.923 9.973h-6.915z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M314.442 309.048a3.278 3.278 0 013.267 3.272 3.282 3.282 0 01-3.267 3.273 3.28 3.28 0 01-3.273-3.273 3.275 3.275 0 013.273-3.272z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M255.646 247.994h8.121v11.979h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.616 8.625 12.883 0 5.765-2.412 13.184-9.228 13.184-3.156 0-5.211-1.501-6.817-3.913l-1.501 3.618h-4.214v-35.696zm8.121 27.617c-.148 2.11 1.101 3.267 2.658 3.267 2.251 0 2.559-2.264 2.559-6.921v-1.907c0-5.008 0-7.616-2.51-7.616-1.003 0-1.754.597-2.258 1.003l-.449.449v11.725z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M272.749 247.994h8.121v11.979h.098c1.15-1.206 3.255-2.055 4.916-2.055 5.61 0 8.619 5.616 8.619 12.883 0 5.765-2.406 13.184-9.222 13.184-3.163 0-5.217-1.501-6.823-3.913l-1.501 3.618h-4.208v-35.696zm8.121 27.617c-.154 2.11 1.101 3.267 2.651 3.267 2.258 0 2.56-2.264 2.56-6.921v-1.907c0-5.008 0-7.616-2.504-7.616-1.009 0-1.76.597-2.258 1.003l-.449.449v11.725z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M290.073 264.236h-3.304v-5.716h3.304v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.606 0 2.805.147 4.11.295v6.22c-.449-.104-1.052-.202-1.501-.202-2.055 0-2.91.658-2.91 2.159v2.756h4.411v5.716h-4.411v19.453h-8.121v-19.453z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M310.984 267.89c0-.997-.055-2.203-.4-3.156-.406-.997-1.058-1.704-2.362-1.704-2.707 0-3.002 3.31-3.002 8.324 0 5.66.898 7.523 3.002 7.523 2.861 0 3.107-2.91 3.107-4.823l6.318.904c-.597 6.122-4.11 9.327-10.022 9.327-7.321 0-11.129-6.417-11.129-12.631 0-6.872 3.808-13.737 11.48-13.737 8.619 0 9.923 7.469 9.923 9.973h-6.915z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M314.442 267.909a3.28 3.28 0 013.267 3.279 3.282 3.282 0 01-3.267 3.272 3.276 3.276 0 010-6.551z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M255.646 206.867h8.121v11.978h.098c1.157-1.199 3.261-2.055 4.916-2.055 5.617 0 8.625 5.611 8.625 12.883 0 5.759-2.412 13.178-9.228 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.501 3.605h-4.214v-35.683zm8.121 27.617c-.148 2.104 1.101 3.254 2.658 3.254 2.251 0 2.559-2.258 2.559-6.915v-1.907c0-5.014 0-7.616-2.51-7.616-1.003 0-1.754.603-2.258 1.003l-.449.449v11.732z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M272.749 206.867h8.121v11.978h.098c1.15-1.199 3.255-2.055 4.916-2.055 5.61 0 8.619 5.611 8.619 12.883 0 5.759-2.406 13.178-9.222 13.178-3.163 0-5.217-1.501-6.823-3.906l-1.501 3.605h-4.208v-35.683zm8.121 27.617c-.154 2.104 1.101 3.254 2.651 3.254 2.258 0 2.56-2.258 2.56-6.915v-1.907c0-5.014 0-7.616-2.504-7.616-1.009 0-1.76.603-2.258 1.003l-.449.449v11.732z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M290.073 223.102h-3.304v-5.709h3.304v-2.806c0-6.165 3.058-8.423 8.422-8.423 1.606 0 2.805.148 4.11.296v6.22c-.449-.104-1.052-.203-1.501-.203-2.055 0-2.91.652-2.91 2.159v2.757h4.411v5.709h-4.411v19.447h-8.121v-19.447z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M310.984 226.762c0-1.003-.055-2.208-.4-3.156-.406-1.002-1.058-1.704-2.362-1.704-2.707 0-3.002 3.304-3.002 8.318 0 5.666.898 7.518 3.002 7.518 2.861 0 3.107-2.903 3.107-4.811l6.318.897c-.597 6.122-4.11 9.327-10.022 9.327-7.321 0-11.129-6.417-11.129-12.63 0-6.866 3.808-13.732 11.48-13.732 8.619 0 9.923 7.463 9.923 9.973h-6.915z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M314.442 226.781a3.279 3.279 0 013.267 3.273 3.282 3.282 0 01-3.267 3.272 3.28 3.28 0 01-3.273-3.272 3.275 3.275 0 013.273-3.273z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M328.285 289.127h8.127v11.984h.098c1.157-1.206 3.255-2.055 4.91-2.055 5.617 0 8.625 5.61 8.625 12.883 0 5.765-2.406 13.178-9.222 13.178-3.156 0-5.217-1.501-6.817-3.906l-1.507 3.604h-4.214v-35.688zm8.127 27.623c-.154 2.104 1.101 3.255 2.652 3.255 2.258 0 2.559-2.252 2.559-6.915v-1.907c0-5.015 0-7.616-2.51-7.616-.997 0-1.753.603-2.251 1.002l-.449.449v11.732z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M345.388 289.127h8.121v11.984h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.619 5.61 8.619 12.883 0 5.765-2.405 13.178-9.222 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.507 3.604h-4.208v-35.688zm8.121 27.623c-.148 2.104 1.107 3.255 2.658 3.255 2.251 0 2.559-2.252 2.559-6.915v-1.907c0-5.015 0-7.616-2.51-7.616-1.002 0-1.753.603-2.251 1.002l-.455.449v11.732z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M362.718 305.37h-3.31v-5.716h3.31v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.6 0 2.806.153 4.11.301v6.214c-.449-.099-1.052-.196-1.507-.196-2.055 0-2.904.646-2.904 2.153v2.756h4.411v5.716h-4.411v19.446h-8.121V305.37z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M383.624 309.03c0-1.003-.049-2.202-.4-3.156-.4-1.009-1.052-1.704-2.356-1.704-2.707 0-3.008 3.304-3.008 8.317 0 5.667.904 7.519 3.008 7.519 2.855 0 3.107-2.904 3.107-4.812l6.318.904c-.603 6.116-4.116 9.327-10.028 9.327-7.321 0-11.129-6.417-11.129-12.637 0-6.866 3.808-13.731 11.48-13.731 8.625 0 9.93 7.463 9.93 9.973h-6.922z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M387.081 309.048a3.279 3.279 0 013.273 3.272 3.283 3.283 0 01-3.273 3.273 3.28 3.28 0 01-3.273-3.273 3.275 3.275 0 013.273-3.272z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M328.285 247.994h8.127v11.979h.098c1.157-1.206 3.255-2.055 4.91-2.055 5.617 0 8.625 5.616 8.625 12.883 0 5.765-2.406 13.184-9.222 13.184-3.156 0-5.217-1.501-6.817-3.913l-1.507 3.618h-4.214v-35.696zm8.127 27.617c-.154 2.11 1.101 3.267 2.652 3.267 2.258 0 2.559-2.264 2.559-6.921v-1.907c0-5.008 0-7.616-2.51-7.616-.997 0-1.753.597-2.251 1.003l-.449.449v11.725z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M345.388 247.994h8.121v11.979h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.619 5.616 8.619 12.883 0 5.765-2.405 13.184-9.222 13.184-3.156 0-5.211-1.501-6.817-3.913l-1.507 3.618h-4.208v-35.696zm8.121 27.617c-.148 2.11 1.107 3.267 2.658 3.267 2.251 0 2.559-2.264 2.559-6.921v-1.907c0-5.008 0-7.616-2.51-7.616-1.002 0-1.753.597-2.251 1.003l-.455.449v11.725z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M362.718 264.236h-3.31v-5.716h3.31v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.6 0 2.806.147 4.11.295v6.22c-.449-.104-1.052-.202-1.507-.202-2.055 0-2.904.658-2.904 2.159v2.756h4.411v5.716h-4.411v19.453h-8.121v-19.453z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M383.624 267.89c0-.997-.049-2.203-.4-3.156-.4-.997-1.052-1.704-2.356-1.704-2.707 0-3.008 3.31-3.008 8.324 0 5.66.904 7.523 3.008 7.523 2.855 0 3.107-2.91 3.107-4.823l6.318.904c-.603 6.122-4.116 9.327-10.028 9.327-7.321 0-11.129-6.417-11.129-12.631 0-6.872 3.808-13.737 11.48-13.737 8.625 0 9.93 7.469 9.93 9.973h-6.922z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M387.081 267.909a3.28 3.28 0 013.273 3.279 3.283 3.283 0 01-3.273 3.272 3.276 3.276 0 010-6.551z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M328.285 206.867h8.127v11.978h.098c1.157-1.199 3.255-2.055 4.91-2.055 5.617 0 8.625 5.611 8.625 12.883 0 5.759-2.406 13.178-9.222 13.178-3.156 0-5.217-1.501-6.817-3.906l-1.507 3.605h-4.214v-35.683zm8.127 27.617c-.154 2.104 1.101 3.254 2.652 3.254 2.258 0 2.559-2.258 2.559-6.915v-1.907c0-5.014 0-7.616-2.51-7.616-.997 0-1.753.603-2.251 1.003l-.449.449v11.732z"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M345.388 206.867h8.121v11.978h.098c1.157-1.199 3.261-2.055 4.916-2.055 5.617 0 8.619 5.611 8.619 12.883 0 5.759-2.405 13.178-9.222 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.507 3.605h-4.208v-35.683zm8.121 27.617c-.148 2.104 1.107 3.254 2.658 3.254 2.251 0 2.559-2.258 2.559-6.915v-1.907c0-5.014 0-7.616-2.51-7.616-1.002 0-1.753.603-2.251 1.003l-.455.449v11.732z"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M362.718 223.102h-3.31v-5.709h3.31v-2.806c0-6.165 3.058-8.423 8.422-8.423 1.6 0 2.806.148 4.11.296v6.22c-.449-.104-1.052-.203-1.507-.203-2.055 0-2.904.652-2.904 2.159v2.757h4.411v5.709h-4.411v19.447h-8.121v-19.447z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M383.624 226.762c0-1.003-.049-2.208-.4-3.156-.4-1.002-1.052-1.704-2.356-1.704-2.707 0-3.008 3.304-3.008 8.318 0 5.666.904 7.518 3.008 7.518 2.855 0 3.107-2.903 3.107-4.811l6.318.897c-.603 6.122-4.116 9.327-10.028 9.327-7.321 0-11.129-6.417-11.129-12.63 0-6.866 3.808-13.732 11.48-13.732 8.625 0 9.93 7.463 9.93 9.973h-6.922z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M387.081 226.781a3.28 3.28 0 013.273 3.273 3.283 3.283 0 01-3.273 3.272 3.28 3.28 0 01-3.273-3.272 3.275 3.275 0 013.273-3.273z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M183.451 165.734h8.121v11.983h.099c1.157-1.206 3.261-2.06 4.916-2.06 5.617 0 8.625 5.615 8.625 12.888 0 5.765-2.406 13.178-9.229 13.178-3.156 0-5.214-1.501-6.816-3.906l-1.504 3.604h-4.211v-35.687zm8.121 27.622c-.151 2.104 1.104 3.255 2.658 3.255 2.255 0 2.557-2.252 2.557-6.915v-1.907c0-5.008 0-7.616-2.507-7.616-1 0-1.753.603-2.255 1.002l-.452.449v11.732z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M200.554 165.734h8.121v11.983h.099c1.15-1.206 3.259-2.06 4.914-2.06 5.611 0 8.619 5.615 8.619 12.888 0 5.765-2.405 13.178-9.222 13.178-3.161 0-5.215-1.501-6.821-3.906l-1.501 3.604h-4.208v-35.687zm8.121 27.622c-.153 2.104 1.102 3.255 2.656 3.255 2.252 0 2.553-2.252 2.553-6.915v-1.907c0-5.008 0-7.616-2.504-7.616-1.001 0-1.751.603-2.256 1.002l-.449.449v11.732z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M217.877 181.974h-3.304v-5.715h3.304v-2.804c0-6.165 3.058-8.423 8.423-8.423 1.605 0 2.812.154 4.115.302v6.214c-.455-.099-1.058-.197-1.507-.197-2.055 0-2.91.652-2.91 2.153v2.755h4.417v5.715h-4.417v19.447h-8.121v-19.447z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M238.789 185.635c0-1.003-.055-2.209-.4-3.156-.406-1.003-1.052-1.704-2.356-1.704-2.713 0-3.008 3.304-3.008 8.317 0 5.666.898 7.519 3.008 7.519 2.854 0 3.107-2.904 3.107-4.812l6.312.898c-.597 6.121-4.109 9.333-10.021 9.333-7.321 0-11.13-6.423-11.13-12.637 0-6.866 3.809-13.736 11.48-13.736 8.625 0 9.923 7.467 9.923 9.978h-6.915z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M242.246 185.654a3.278 3.278 0 013.267 3.272 3.282 3.282 0 01-3.267 3.273 3.28 3.28 0 01-3.273-3.273 3.276 3.276 0 013.273-3.272z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M111.258 165.734h8.121v11.983h.099c1.156-1.206 3.261-2.06 4.916-2.06 5.614 0 8.622 5.615 8.622 12.888 0 5.765-2.405 13.178-9.225 13.178-3.156 0-5.214-1.501-6.816-3.906l-1.504 3.604h-4.211v-35.687zm8.121 27.622c-.151 2.104 1.104 3.255 2.658 3.255 2.255 0 2.556-2.252 2.556-6.915v-1.907c0-5.008 0-7.616-2.507-7.616-1 0-1.753.603-2.255 1.002l-.452.449v11.732z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M128.358 165.734h8.124v11.983h.099c1.15-1.206 3.257-2.06 4.913-2.06 5.614 0 8.619 5.615 8.619 12.888 0 5.765-2.406 13.178-9.222 13.178-3.159 0-5.214-1.501-6.82-3.906l-1.504 3.604h-4.208v-35.687zm8.124 27.622c-.154 2.104 1.101 3.255 2.655 3.255 2.255 0 2.556-2.252 2.556-6.915v-1.907c0-5.008 0-7.616-2.507-7.616-1.003 0-1.753.603-2.255 1.002l-.449.449v11.732z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M145.686 181.974h-3.307v-5.715h3.307v-2.804c0-6.165 3.058-8.423 8.422-8.423 1.603 0 2.809.154 4.113.302v6.214c-.452-.099-1.055-.197-1.504-.197-2.058 0-2.91.652-2.91 2.153v2.755h4.414v5.715h-4.414v19.447h-8.121v-19.447z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M166.597 185.635c0-1.003-.056-2.209-.403-3.156-.403-1.003-1.052-1.704-2.356-1.704-2.71 0-3.009 3.304-3.009 8.317 0 5.666.901 7.519 3.009 7.519 2.857 0 3.106-2.904 3.106-4.812l6.315.898c-.6 6.121-4.109 9.333-10.025 9.333-7.318 0-11.126-6.423-11.126-12.637 0-6.866 3.809-13.736 11.48-13.736 8.622 0 9.923 7.467 9.923 9.978h-6.914z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M170.052 185.654c1.799 0 3.27 1.47 3.27 3.272a3.282 3.282 0 01-3.27 3.273 3.279 3.279 0 01-3.27-3.273 3.274 3.274 0 013.27-3.272z"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M39.065 165.734h8.121v11.983h.098c1.157-1.206 3.261-2.06 4.916-2.06 5.614 0 8.622 5.615 8.622 12.888 0 5.765-2.405 13.178-9.225 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.501 3.604h-4.214v-35.687zm8.121 27.622c-.151 2.104 1.104 3.255 2.658 3.255 2.251 0 2.556-2.252 2.556-6.915v-1.907c0-5.008 0-7.616-2.507-7.616-1.002 0-1.753.603-2.254 1.002l-.452.449v11.732z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M56.165 165.734h8.124v11.983h.099c1.15-1.206 3.257-2.06 4.912-2.06 5.614 0 8.619 5.615 8.619 12.888 0 5.765-2.405 13.178-9.222 13.178-3.159 0-5.214-1.501-6.82-3.906l-1.501 3.604h-4.211v-35.687zm8.124 27.622c-.154 2.104 1.101 3.255 2.655 3.255 2.254 0 2.556-2.252 2.556-6.915v-1.907c0-5.008 0-7.616-2.507-7.616-1.006 0-1.757.603-2.255 1.002l-.449.449v11.732z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M73.493 181.974h-3.307v-5.715h3.307v-2.804c0-6.165 3.058-8.423 8.422-8.423 1.605 0 2.809.154 4.11.302v6.214c-.449-.099-1.052-.197-1.501-.197-2.058 0-2.91.652-2.91 2.153v2.755h4.411v5.715h-4.411v19.447h-8.121v-19.447z"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M94.404 185.635c0-1.003-.056-2.209-.403-3.156-.403-1.003-1.055-1.704-2.356-1.704-2.71 0-3.008 3.304-3.008 8.317 0 5.666.901 7.519 3.008 7.519 2.858 0 3.107-2.904 3.107-4.812l6.315.898c-.6 6.121-4.11 9.333-10.025 9.333-7.318 0-11.126-6.423-11.126-12.637 0-6.866 3.808-13.736 11.48-13.736 8.623 0 9.924 7.467 9.924 9.978h-6.916z"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M97.858 185.654c1.8 0 3.27 1.47 3.27 3.272a3.282 3.282 0 01-3.27 3.273 3.279 3.279 0 01-3.27-3.273 3.276 3.276 0 013.27-3.272z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M255.646 165.734h8.121v11.983h.098c1.157-1.206 3.261-2.06 4.916-2.06 5.617 0 8.625 5.615 8.625 12.888 0 5.765-2.412 13.178-9.228 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.501 3.604h-4.214v-35.687zm8.121 27.622c-.148 2.104 1.101 3.255 2.658 3.255 2.251 0 2.559-2.252 2.559-6.915v-1.907c0-5.008 0-7.616-2.51-7.616-1.003 0-1.754.603-2.258 1.002l-.449.449v11.732z"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M272.749 165.734h8.121v11.983h.098c1.15-1.206 3.255-2.06 4.916-2.06 5.61 0 8.619 5.615 8.619 12.888 0 5.765-2.406 13.178-9.222 13.178-3.163 0-5.217-1.501-6.823-3.906l-1.501 3.604h-4.208v-35.687zm8.121 27.622c-.154 2.104 1.101 3.255 2.651 3.255 2.258 0 2.56-2.252 2.56-6.915v-1.907c0-5.008 0-7.616-2.504-7.616-1.009 0-1.76.603-2.258 1.002l-.449.449v11.732z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M290.073 181.974h-3.304v-5.715h3.304v-2.804c0-6.165 3.058-8.423 8.422-8.423 1.606 0 2.805.154 4.11.302v6.214c-.449-.099-1.052-.197-1.501-.197-2.055 0-2.91.652-2.91 2.153v2.755h4.411v5.715h-4.411v19.447h-8.121v-19.447z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M310.984 185.635c0-1.003-.055-2.209-.4-3.156-.406-1.003-1.058-1.704-2.362-1.704-2.707 0-3.002 3.304-3.002 8.317 0 5.666.898 7.519 3.002 7.519 2.861 0 3.107-2.904 3.107-4.812l6.318.898c-.597 6.121-4.11 9.333-10.022 9.333-7.321 0-11.129-6.423-11.129-12.637 0-6.866 3.808-13.736 11.48-13.736 8.619 0 9.923 7.467 9.923 9.978h-6.915z"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M314.442 185.654a3.278 3.278 0 013.267 3.272 3.282 3.282 0 01-3.267 3.273 3.28 3.28 0 01-3.273-3.273 3.275 3.275 0 013.273-3.272z"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M328.285 165.734h8.127v11.983h.098c1.157-1.206 3.255-2.06 4.91-2.06 5.617 0 8.625 5.615 8.625 12.888 0 5.765-2.406 13.178-9.222 13.178-3.156 0-5.217-1.501-6.817-3.906l-1.507 3.604h-4.214v-35.687zm8.127 27.622c-.154 2.104 1.101 3.255 2.652 3.255 2.258 0 2.559-2.252 2.559-6.915v-1.907c0-5.008 0-7.616-2.51-7.616-.997 0-1.753.603-2.251 1.002l-.449.449v11.732z"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M345.388 165.734h8.121v11.983h.098c1.157-1.206 3.261-2.06 4.916-2.06 5.617 0 8.619 5.615 8.619 12.888 0 5.765-2.405 13.178-9.222 13.178-3.156 0-5.211-1.501-6.817-3.906l-1.507 3.604h-4.208v-35.687zm8.121 27.622c-.148 2.104 1.107 3.255 2.658 3.255 2.251 0 2.559-2.252 2.559-6.915v-1.907c0-5.008 0-7.616-2.51-7.616-1.002 0-1.753.603-2.251 1.002l-.455.449v11.732z"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M362.718 181.974h-3.31v-5.715h3.31v-2.804c0-6.165 3.058-8.423 8.422-8.423 1.6 0 2.806.154 4.11.302v6.214c-.449-.099-1.052-.197-1.507-.197-2.055 0-2.904.652-2.904 2.153v2.755h4.411v5.715h-4.411v19.447h-8.121v-19.447z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M383.624 185.635c0-1.003-.049-2.209-.4-3.156-.4-1.003-1.052-1.704-2.356-1.704-2.707 0-3.008 3.304-3.008 8.317 0 5.666.904 7.519 3.008 7.519 2.855 0 3.107-2.904 3.107-4.812l6.318.898c-.603 6.121-4.116 9.333-10.028 9.333-7.321 0-11.129-6.423-11.129-12.637 0-6.866 3.808-13.736 11.48-13.736 8.625 0 9.93 7.467 9.93 9.978h-6.922z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M387.081 185.654a3.279 3.279 0 013.273 3.272 3.283 3.283 0 01-3.273 3.273 3.28 3.28 0 01-3.273-3.273 3.275 3.275 0 013.273-3.272z"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M183.451 124.599h8.121v11.984h.099c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.611 8.625 12.884 0 5.765-2.406 13.178-9.229 13.178-3.156 0-5.214-1.501-6.816-3.907l-1.504 3.611h-4.211v-35.695zm8.121 27.625c-.151 2.104 1.104 3.261 2.658 3.261 2.255 0 2.557-2.258 2.557-6.921v-1.907c0-5.009 0-7.618-2.507-7.618-1 0-1.753.603-2.255 1.003l-.452.449v11.733z"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M200.554 124.599h8.121v11.984h.099c1.15-1.206 3.259-2.055 4.914-2.055 5.611 0 8.619 5.611 8.619 12.884 0 5.765-2.405 13.178-9.222 13.178-3.161 0-5.215-1.501-6.821-3.907l-1.501 3.611h-4.208v-35.695zm8.121 27.625c-.153 2.104 1.102 3.261 2.656 3.261 2.252 0 2.553-2.258 2.553-6.921v-1.907c0-5.009 0-7.618-2.504-7.618-1.001 0-1.751.603-2.256 1.003l-.449.449v11.733z"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M217.877 140.841h-3.304v-5.715h3.304v-2.806c0-6.164 3.058-8.422 8.423-8.422 1.605 0 2.812.153 4.115.301v6.214c-.455-.099-1.058-.197-1.507-.197-2.055 0-2.91.652-2.91 2.153v2.756h4.417v5.715h-4.417v19.455h-8.121v-19.454z"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M238.789 144.501c0-1.003-.055-2.203-.4-3.156-.406-1.003-1.052-1.704-2.356-1.704-2.713 0-3.008 3.304-3.008 8.319 0 5.666.898 7.524 3.008 7.524 2.854 0 3.107-2.91 3.107-4.817l6.312.904c-.597 6.115-4.109 9.327-10.021 9.327-7.321 0-11.13-6.423-11.13-12.636 0-6.868 3.809-13.733 11.48-13.733 8.625 0 9.923 7.462 9.923 9.973h-6.915z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M242.246 144.52a3.279 3.279 0 013.267 3.274 3.282 3.282 0 01-3.267 3.273 3.28 3.28 0 01-3.273-3.273 3.276 3.276 0 013.273-3.274z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M111.258 124.599h8.121v11.984h.099c1.156-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.611 8.622 12.884 0 5.765-2.405 13.178-9.225 13.178-3.156 0-5.214-1.501-6.816-3.907l-1.504 3.611h-4.211v-35.695zm8.121 27.625c-.151 2.104 1.104 3.261 2.658 3.261 2.255 0 2.556-2.258 2.556-6.921v-1.907c0-5.009 0-7.618-2.507-7.618-1 0-1.753.603-2.255 1.003l-.452.449v11.733z"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M128.358 124.599h8.124v11.984h.099c1.15-1.206 3.257-2.055 4.913-2.055 5.614 0 8.619 5.611 8.619 12.884 0 5.765-2.406 13.178-9.222 13.178-3.159 0-5.214-1.501-6.82-3.907l-1.504 3.611h-4.208v-35.695zm8.124 27.625c-.154 2.104 1.101 3.261 2.655 3.261 2.255 0 2.556-2.258 2.556-6.921v-1.907c0-5.009 0-7.618-2.507-7.618-1.003 0-1.753.603-2.255 1.003l-.449.449v11.733z"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M145.686 140.841h-3.307v-5.715h3.307v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.603 0 2.809.153 4.113.301v6.214c-.452-.099-1.055-.197-1.504-.197-2.058 0-2.91.652-2.91 2.153v2.756h4.414v5.715h-4.414v19.455h-8.121v-19.454z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M166.597 144.501c0-1.003-.056-2.203-.403-3.156-.403-1.003-1.052-1.704-2.356-1.704-2.71 0-3.009 3.304-3.009 8.319 0 5.666.901 7.524 3.009 7.524 2.857 0 3.106-2.91 3.106-4.817l6.315.904c-.6 6.115-4.109 9.327-10.025 9.327-7.318 0-11.126-6.423-11.126-12.636 0-6.868 3.809-13.733 11.48-13.733 8.622 0 9.923 7.462 9.923 9.973h-6.914z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M170.052 144.52a3.28 3.28 0 013.27 3.274 3.283 3.283 0 01-3.27 3.273 3.279 3.279 0 01-3.27-3.273 3.275 3.275 0 013.27-3.274z"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M39.065 124.599h8.121v11.984h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.611 8.622 12.884 0 5.765-2.405 13.178-9.225 13.178-3.156 0-5.211-1.501-6.817-3.907l-1.501 3.611h-4.214v-35.695zm8.121 27.625c-.151 2.104 1.104 3.261 2.658 3.261 2.251 0 2.556-2.258 2.556-6.921v-1.907c0-5.009 0-7.618-2.507-7.618-1.002 0-1.753.603-2.254 1.003l-.452.449v11.733z"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M56.165 124.599h8.124v11.984h.099c1.15-1.206 3.257-2.055 4.912-2.055 5.614 0 8.619 5.611 8.619 12.884 0 5.765-2.405 13.178-9.222 13.178-3.159 0-5.214-1.501-6.82-3.907l-1.501 3.611h-4.211v-35.695zm8.124 27.625c-.154 2.104 1.101 3.261 2.655 3.261 2.254 0 2.556-2.258 2.556-6.921v-1.907c0-5.009 0-7.618-2.507-7.618-1.006 0-1.757.603-2.255 1.003l-.449.449v11.733z"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M73.493 140.841h-3.307v-5.715h3.307v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.605 0 2.809.153 4.11.301v6.214c-.449-.099-1.052-.197-1.501-.197-2.058 0-2.91.652-2.91 2.153v2.756h4.411v5.715h-4.411v19.455h-8.121v-19.454z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M94.404 144.501c0-1.003-.056-2.203-.403-3.156-.403-1.003-1.055-1.704-2.356-1.704-2.71 0-3.008 3.304-3.008 8.319 0 5.666.901 7.524 3.008 7.524 2.858 0 3.107-2.91 3.107-4.817l6.315.904c-.6 6.115-4.11 9.327-10.025 9.327-7.318 0-11.126-6.423-11.126-12.636 0-6.868 3.808-13.733 11.48-13.733 8.623 0 9.924 7.462 9.924 9.973h-6.916z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M97.858 144.52c1.8 0 3.27 1.47 3.27 3.274a3.283 3.283 0 01-3.27 3.273 3.279 3.279 0 01-3.27-3.273 3.276 3.276 0 013.27-3.274z"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M255.646 124.599h8.121v11.984h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.611 8.625 12.884 0 5.765-2.412 13.178-9.228 13.178-3.156 0-5.211-1.501-6.817-3.907l-1.501 3.611h-4.214v-35.695zm8.121 27.625c-.148 2.104 1.101 3.261 2.658 3.261 2.251 0 2.559-2.258 2.559-6.921v-1.907c0-5.009 0-7.618-2.51-7.618-1.003 0-1.754.603-2.258 1.003l-.449.449v11.733z"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M272.749 124.599h8.121v11.984h.098c1.15-1.206 3.255-2.055 4.916-2.055 5.61 0 8.619 5.611 8.619 12.884 0 5.765-2.406 13.178-9.222 13.178-3.163 0-5.217-1.501-6.823-3.907l-1.501 3.611h-4.208v-35.695zm8.121 27.625c-.154 2.104 1.101 3.261 2.651 3.261 2.258 0 2.56-2.258 2.56-6.921v-1.907c0-5.009 0-7.618-2.504-7.618-1.009 0-1.76.603-2.258 1.003l-.449.449v11.733z"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M290.073 140.841h-3.304v-5.715h3.304v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.606 0 2.805.153 4.11.301v6.214c-.449-.099-1.052-.197-1.501-.197-2.055 0-2.91.652-2.91 2.153v2.756h4.411v5.715h-4.411v19.455h-8.121v-19.454z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M310.984 144.501c0-1.003-.055-2.203-.4-3.156-.406-1.003-1.058-1.704-2.362-1.704-2.707 0-3.002 3.304-3.002 8.319 0 5.666.898 7.524 3.002 7.524 2.861 0 3.107-2.91 3.107-4.817l6.318.904c-.597 6.115-4.11 9.327-10.022 9.327-7.321 0-11.129-6.423-11.129-12.636 0-6.868 3.808-13.733 11.48-13.733 8.619 0 9.923 7.462 9.923 9.973h-6.915z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M314.442 144.52a3.279 3.279 0 013.267 3.274 3.283 3.283 0 01-3.267 3.273 3.28 3.28 0 01-3.273-3.273 3.275 3.275 0 013.273-3.274z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M328.285 124.599h8.127v11.984h.098c1.157-1.206 3.255-2.055 4.91-2.055 5.617 0 8.625 5.611 8.625 12.884 0 5.765-2.406 13.178-9.222 13.178-3.156 0-5.217-1.501-6.817-3.907l-1.507 3.611h-4.214v-35.695zm8.127 27.625c-.154 2.104 1.101 3.261 2.652 3.261 2.258 0 2.559-2.258 2.559-6.921v-1.907c0-5.009 0-7.618-2.51-7.618-.997 0-1.753.603-2.251 1.003l-.449.449v11.733z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M345.388 124.599h8.121v11.984h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.619 5.611 8.619 12.884 0 5.765-2.405 13.178-9.222 13.178-3.156 0-5.211-1.501-6.817-3.907l-1.507 3.611h-4.208v-35.695zm8.121 27.625c-.148 2.104 1.107 3.261 2.658 3.261 2.251 0 2.559-2.258 2.559-6.921v-1.907c0-5.009 0-7.618-2.51-7.618-1.002 0-1.753.603-2.251 1.003l-.455.449v11.733z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M362.718 140.841h-3.31v-5.715h3.31v-2.806c0-6.164 3.058-8.422 8.422-8.422 1.6 0 2.806.153 4.11.301v6.214c-.449-.099-1.052-.197-1.507-.197-2.055 0-2.904.652-2.904 2.153v2.756h4.411v5.715h-4.411v19.455h-8.121v-19.454z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M383.624 144.501c0-1.003-.049-2.203-.4-3.156-.4-1.003-1.052-1.704-2.356-1.704-2.707 0-3.008 3.304-3.008 8.319 0 5.666.904 7.524 3.008 7.524 2.855 0 3.107-2.91 3.107-4.817l6.318.904c-.603 6.115-4.116 9.327-10.028 9.327-7.321 0-11.129-6.423-11.129-12.636 0-6.868 3.808-13.733 11.48-13.733 8.625 0 9.93 7.462 9.93 9.973h-6.922z"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M387.081 144.52a3.28 3.28 0 013.273 3.274 3.283 3.283 0 01-3.273 3.273 3.28 3.28 0 01-3.273-3.273 3.275 3.275 0 013.273-3.274z"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M183.451 83.465h8.121V95.45h.099c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.611 8.625 12.883 0 5.765-2.406 13.184-9.229 13.184-3.156 0-5.214-1.501-6.816-3.913l-1.504 3.611h-4.211V83.465zm8.121 27.624c-.151 2.107 1.104 3.261 2.658 3.261 2.255 0 2.557-2.258 2.557-6.921v-1.904c0-5.011 0-7.619-2.507-7.619-1 0-1.753.603-2.255 1.003l-.452.452v11.728z"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M200.554 83.465h8.121V95.45h.099c1.15-1.206 3.259-2.055 4.914-2.055 5.611 0 8.619 5.611 8.619 12.883 0 5.765-2.405 13.184-9.222 13.184-3.161 0-5.215-1.501-6.821-3.913l-1.501 3.611h-4.208V83.465zm8.121 27.624c-.153 2.107 1.102 3.261 2.656 3.261 2.252 0 2.553-2.258 2.553-6.921v-1.904c0-5.011 0-7.619-2.504-7.619-1.001 0-1.751.603-2.256 1.003l-.449.452v11.728z"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M217.877 99.708h-3.304v-5.712h3.304v-2.809c0-6.165 3.058-8.422 8.423-8.422 1.605 0 2.812.154 4.115.301v6.217c-.455-.102-1.058-.2-1.507-.2-2.055 0-2.91.652-2.91 2.153v2.759h4.417v5.712h-4.417v19.453h-8.121V99.708z"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M238.789 103.368c0-1-.055-2.202-.4-3.156-.406-1.003-1.052-1.705-2.356-1.705-2.713 0-3.008 3.307-3.008 8.318 0 5.667.898 7.524 3.008 7.524 2.854 0 3.107-2.91 3.107-4.817l6.312.904c-.597 6.116-4.109 9.327-10.021 9.327-7.321 0-11.13-6.419-11.13-12.633 0-6.869 3.809-13.735 11.48-13.735 8.625 0 9.923 7.466 9.923 9.973h-6.915z"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M242.246 103.386a3.278 3.278 0 013.267 3.273 3.28 3.28 0 01-3.267 3.273 3.278 3.278 0 01-3.273-3.273 3.276 3.276 0 013.273-3.273z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M111.258 83.465h8.121V95.45h.099c1.156-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.611 8.622 12.883 0 5.765-2.405 13.184-9.225 13.184-3.156 0-5.214-1.501-6.816-3.913l-1.504 3.611h-4.211V83.465zm8.121 27.624c-.151 2.107 1.104 3.261 2.658 3.261 2.255 0 2.556-2.258 2.556-6.921v-1.904c0-5.011 0-7.619-2.507-7.619-1 0-1.753.603-2.255 1.003l-.452.452v11.728z"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M128.358 83.465h8.124V95.45h.099c1.15-1.206 3.257-2.055 4.913-2.055 5.614 0 8.619 5.611 8.619 12.883 0 5.765-2.406 13.184-9.222 13.184-3.159 0-5.214-1.501-6.82-3.913l-1.504 3.611h-4.208V83.465zm8.124 27.624c-.154 2.107 1.101 3.261 2.655 3.261 2.255 0 2.556-2.258 2.556-6.921v-1.904c0-5.011 0-7.619-2.507-7.619-1.003 0-1.753.603-2.255 1.003l-.449.452v11.728z"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M145.686 99.708h-3.307v-5.712h3.307v-2.809c0-6.165 3.058-8.422 8.422-8.422 1.603 0 2.809.154 4.113.301v6.217c-.452-.102-1.055-.2-1.504-.2-2.058 0-2.91.652-2.91 2.153v2.759h4.414v5.712h-4.414v19.453h-8.121V99.708z"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M166.597 103.368c0-1-.056-2.202-.403-3.156-.403-1.003-1.052-1.705-2.356-1.705-2.71 0-3.009 3.307-3.009 8.318 0 5.667.901 7.524 3.009 7.524 2.857 0 3.106-2.91 3.106-4.817l6.315.904c-.6 6.116-4.109 9.327-10.025 9.327-7.318 0-11.126-6.419-11.126-12.633 0-6.869 3.809-13.735 11.48-13.735 8.622 0 9.923 7.466 9.923 9.973h-6.914z"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M170.052 103.386c1.799 0 3.27 1.47 3.27 3.273a3.28 3.28 0 01-3.27 3.273 3.277 3.277 0 01-3.27-3.273 3.274 3.274 0 013.27-3.273z"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M39.065 83.465h8.121V95.45h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.611 8.622 12.883 0 5.765-2.405 13.184-9.225 13.184-3.156 0-5.211-1.501-6.817-3.913l-1.501 3.611h-4.214V83.465zm8.121 27.624c-.151 2.107 1.104 3.261 2.658 3.261 2.251 0 2.556-2.258 2.556-6.921v-1.904c0-5.011 0-7.619-2.507-7.619-1.002 0-1.753.603-2.254 1.003l-.452.452v11.728z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M56.165 83.465h8.124V95.45h.099c1.15-1.206 3.257-2.055 4.912-2.055 5.614 0 8.619 5.611 8.619 12.883 0 5.765-2.405 13.184-9.222 13.184-3.159 0-5.214-1.501-6.82-3.913l-1.501 3.611h-4.211V83.465zm8.124 27.624c-.154 2.107 1.101 3.261 2.655 3.261 2.254 0 2.556-2.258 2.556-6.921v-1.904c0-5.011 0-7.619-2.507-7.619-1.006 0-1.757.603-2.255 1.003l-.449.452v11.728z"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M73.493 99.708h-3.307v-5.712h3.307v-2.809c0-6.165 3.058-8.422 8.422-8.422 1.605 0 2.809.154 4.11.301v6.217c-.449-.102-1.052-.2-1.501-.2-2.058 0-2.91.652-2.91 2.153v2.759h4.411v5.712h-4.411v19.453h-8.121V99.708z"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M94.404 103.368c0-1-.056-2.202-.403-3.156-.403-1.003-1.055-1.705-2.356-1.705-2.71 0-3.008 3.307-3.008 8.318 0 5.667.901 7.524 3.008 7.524 2.858 0 3.107-2.91 3.107-4.817l6.315.904c-.6 6.116-4.11 9.327-10.025 9.327-7.318 0-11.126-6.419-11.126-12.633 0-6.869 3.808-13.735 11.48-13.735 8.623 0 9.924 7.466 9.924 9.973h-6.916z"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M97.858 103.386c1.8 0 3.27 1.47 3.27 3.273a3.28 3.28 0 01-3.27 3.273 3.277 3.277 0 01-3.27-3.273 3.276 3.276 0 013.27-3.273z"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M255.646 83.465h8.121V95.45h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.611 8.625 12.883 0 5.765-2.412 13.184-9.228 13.184-3.156 0-5.211-1.501-6.817-3.913l-1.501 3.611h-4.214V83.465zm8.121 27.624c-.148 2.107 1.101 3.261 2.658 3.261 2.251 0 2.559-2.258 2.559-6.921v-1.904c0-5.011 0-7.619-2.51-7.619-1.003 0-1.754.603-2.258 1.003l-.449.452v11.728z"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M272.749 83.465h8.121V95.45h.098c1.15-1.206 3.255-2.055 4.916-2.055 5.61 0 8.619 5.611 8.619 12.883 0 5.765-2.406 13.184-9.222 13.184-3.163 0-5.217-1.501-6.823-3.913l-1.501 3.611h-4.208V83.465zm8.121 27.624c-.154 2.107 1.101 3.261 2.651 3.261 2.258 0 2.56-2.258 2.56-6.921v-1.904c0-5.011 0-7.619-2.504-7.619-1.009 0-1.76.603-2.258 1.003l-.449.452v11.728z"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M290.073 99.708h-3.304v-5.712h3.304v-2.809c0-6.165 3.058-8.422 8.422-8.422 1.606 0 2.805.154 4.11.301v6.217c-.449-.102-1.052-.2-1.501-.2-2.055 0-2.91.652-2.91 2.153v2.759h4.411v5.712h-4.411v19.453h-8.121V99.708z"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M310.984 103.368c0-1-.055-2.202-.4-3.156-.406-1.003-1.058-1.705-2.362-1.705-2.707 0-3.002 3.307-3.002 8.318 0 5.667.898 7.524 3.002 7.524 2.861 0 3.107-2.91 3.107-4.817l6.318.904c-.597 6.116-4.11 9.327-10.022 9.327-7.321 0-11.129-6.419-11.129-12.633 0-6.869 3.808-13.735 11.48-13.735 8.619 0 9.923 7.466 9.923 9.973h-6.915z"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M314.442 103.386a3.278 3.278 0 013.267 3.273 3.28 3.28 0 01-3.267 3.273 3.278 3.278 0 01-3.273-3.273 3.275 3.275 0 013.273-3.273z"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M328.285 83.465h8.127V95.45h.098c1.157-1.206 3.255-2.055 4.91-2.055 5.617 0 8.625 5.611 8.625 12.883 0 5.765-2.406 13.184-9.222 13.184-3.156 0-5.217-1.501-6.817-3.913l-1.507 3.611h-4.214V83.465zm8.127 27.624c-.154 2.107 1.101 3.261 2.652 3.261 2.258 0 2.559-2.258 2.559-6.921v-1.904c0-5.011 0-7.619-2.51-7.619-.997 0-1.753.603-2.251 1.003l-.449.452v11.728z"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M345.388 83.465h8.121V95.45h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.619 5.611 8.619 12.883 0 5.765-2.405 13.184-9.222 13.184-3.156 0-5.211-1.501-6.817-3.913l-1.507 3.611h-4.208V83.465zm8.121 27.624c-.148 2.107 1.107 3.261 2.658 3.261 2.251 0 2.559-2.258 2.559-6.921v-1.904c0-5.011 0-7.619-2.51-7.619-1.002 0-1.753.603-2.251 1.003l-.455.452v11.728z"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M362.718 99.708h-3.31v-5.712h3.31v-2.809c0-6.165 3.058-8.422 8.422-8.422 1.6 0 2.806.154 4.11.301v6.217c-.449-.102-1.052-.2-1.507-.2-2.055 0-2.904.652-2.904 2.153v2.759h4.411v5.712h-4.411v19.453h-8.121V99.708z"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M383.624 103.368c0-1-.049-2.202-.4-3.156-.4-1.003-1.052-1.705-2.356-1.705-2.707 0-3.008 3.307-3.008 8.318 0 5.667.904 7.524 3.008 7.524 2.855 0 3.107-2.91 3.107-4.817l6.318.904c-.603 6.116-4.116 9.327-10.028 9.327-7.321 0-11.129-6.419-11.129-12.633 0-6.869 3.808-13.735 11.48-13.735 8.625 0 9.93 7.466 9.93 9.973h-6.922z"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M387.081 103.386a3.279 3.279 0 013.273 3.273 3.282 3.282 0 01-3.273 3.273 3.278 3.278 0 01-3.273-3.273 3.275 3.275 0 013.273-3.273z"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M183.451 42.332h8.121v11.984h.099c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.614 8.625 12.883 0 5.765-2.406 13.185-9.229 13.185-3.156 0-5.214-1.501-6.816-3.913l-1.504 3.611h-4.211V42.332zm8.121 27.623c-.151 2.107 1.104 3.261 2.658 3.261 2.255 0 2.557-2.258 2.557-6.921v-1.904c0-5.011 0-7.62-2.507-7.62-1 0-1.753.603-2.255 1.003l-.452.455v11.726z"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M200.554 42.332h8.121v11.984h.099c1.15-1.206 3.259-2.055 4.914-2.055 5.611 0 8.619 5.614 8.619 12.883 0 5.765-2.405 13.185-9.222 13.185-3.161 0-5.215-1.501-6.821-3.913l-1.501 3.611h-4.208V42.332zm8.121 27.623c-.153 2.107 1.102 3.261 2.656 3.261 2.252 0 2.553-2.258 2.553-6.921v-1.904c0-5.011 0-7.62-2.504-7.62-1.001 0-1.751.603-2.256 1.003l-.449.455v11.726z"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M217.877 58.574h-3.304v-5.709h3.304v-2.812c0-6.165 3.058-8.419 8.423-8.419 1.605 0 2.812.151 4.115.299v6.217c-.455-.102-1.058-.2-1.507-.2-2.055 0-2.91.652-2.91 2.153v2.762h4.417v5.709h-4.417v19.453h-8.121V58.574z"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M238.789 62.234c0-1-.055-2.203-.4-3.156-.406-1.003-1.052-1.704-2.356-1.704-2.713 0-3.008 3.31-3.008 8.321 0 5.663.898 7.521 3.008 7.521 2.854 0 3.107-2.907 3.107-4.817l6.312.904c-.597 6.115-4.109 9.327-10.021 9.327-7.321 0-11.13-6.417-11.13-12.63 0-6.872 3.809-13.738 11.48-13.738 8.625 0 9.923 7.466 9.923 9.973h-6.915z"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M242.246 62.252a3.279 3.279 0 013.267 3.273c0 1.799-1.47 3.276-3.267 3.276a3.28 3.28 0 01-3.273-3.276 3.276 3.276 0 013.273-3.273z"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M111.258 42.332h8.121v11.984h.099c1.156-1.206 3.261-2.055 4.916-2.055 5.614 0 8.622 5.614 8.622 12.883 0 5.765-2.405 13.185-9.225 13.185-3.156 0-5.214-1.501-6.816-3.913l-1.504 3.611h-4.211V42.332zm8.121 27.623c-.151 2.107 1.104 3.261 2.658 3.261 2.255 0 2.556-2.258 2.556-6.921v-1.904c0-5.011 0-7.62-2.507-7.62-1 0-1.753.603-2.255 1.003l-.452.455v11.726z"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M128.358 42.332h8.124v11.984h.099c1.15-1.206 3.257-2.055 4.913-2.055 5.614 0 8.619 5.614 8.619 12.883 0 5.765-2.406 13.185-9.222 13.185-3.159 0-5.214-1.501-6.82-3.913l-1.504 3.611h-4.208V42.332zm8.124 27.623c-.154 2.107 1.101 3.261 2.655 3.261 2.255 0 2.556-2.258 2.556-6.921v-1.904c0-5.011 0-7.62-2.507-7.62-1.003 0-1.753.603-2.255 1.003l-.449.455v11.726z"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M145.686 58.574h-3.307v-5.709h3.307v-2.812c0-6.165 3.058-8.419 8.422-8.419 1.603 0 2.809.151 4.113.299v6.217c-.452-.102-1.055-.2-1.504-.2-2.058 0-2.91.652-2.91 2.153v2.762h4.414v5.709h-4.414v19.453h-8.121V58.574z"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M166.597 62.234c0-1-.056-2.203-.403-3.156-.403-1.003-1.052-1.704-2.356-1.704-2.71 0-3.009 3.31-3.009 8.321 0 5.663.901 7.521 3.009 7.521 2.857 0 3.106-2.907 3.106-4.817l6.315.904c-.6 6.115-4.109 9.327-10.025 9.327-7.318 0-11.126-6.417-11.126-12.63 0-6.872 3.809-13.738 11.48-13.738 8.622 0 9.923 7.466 9.923 9.973h-6.914z"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M170.052 62.252a3.28 3.28 0 013.27 3.273 3.283 3.283 0 01-3.27 3.276 3.28 3.28 0 01-3.27-3.276 3.275 3.275 0 013.27-3.273z"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#58B49E",
  d: "M255.646 42.332h8.121v11.984h.098c1.157-1.206 3.261-2.055 4.916-2.055 5.617 0 8.625 5.614 8.625 12.883 0 5.765-2.412 13.185-9.228 13.185-3.156 0-5.211-1.501-6.817-3.913l-1.501 3.611h-4.214V42.332zm8.121 27.623c-.148 2.107 1.101 3.261 2.658 3.261 2.251 0 2.559-2.258 2.559-6.921v-1.904c0-5.011 0-7.62-2.51-7.62-1.003 0-1.754.603-2.258 1.003l-.449.455v11.726z"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#74BDAB",
  d: "M272.749 42.332h8.121v11.984h.098c1.15-1.206 3.255-2.055 4.916-2.055 5.61 0 8.619 5.614 8.619 12.883 0 5.765-2.406 13.185-9.222 13.185-3.163 0-5.217-1.501-6.823-3.913l-1.501 3.611h-4.208V42.332zm8.121 27.623c-.154 2.107 1.101 3.261 2.651 3.261 2.258 0 2.56-2.258 2.56-6.921v-1.904c0-5.011 0-7.62-2.504-7.62-1.009 0-1.76.603-2.258 1.003l-.449.455v11.726z"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#8FC8B9",
  d: "M290.073 58.574h-3.304v-5.709h3.304v-2.812c0-6.165 3.058-8.419 8.422-8.419 1.606 0 2.805.151 4.11.299v6.217c-.449-.102-1.052-.2-1.501-.2-2.055 0-2.91.652-2.91 2.153v2.762h4.411v5.709h-4.411v19.453h-8.121V58.574z"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#A9D4C8",
  d: "M310.984 62.234c0-1-.055-2.203-.4-3.156-.406-1.003-1.058-1.704-2.362-1.704-2.707 0-3.002 3.31-3.002 8.321 0 5.663.898 7.521 3.002 7.521 2.861 0 3.107-2.907 3.107-4.817l6.318.904c-.597 6.115-4.11 9.327-10.022 9.327-7.321 0-11.129-6.417-11.129-12.63 0-6.872 3.808-13.738 11.48-13.738 8.619 0 9.923 7.466 9.923 9.973h-6.915z"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#rating-uc_svg__b)",
  fill: "#C3E0D7",
  d: "M314.442 62.252a3.279 3.279 0 013.267 3.273c0 1.799-1.471 3.276-3.267 3.276a3.28 3.28 0 01-3.273-3.276 3.276 3.276 0 013.273-3.273z"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  d: "M204.711 300.623c-23.821 0-43.296-16.094-43.296-41.207v-74.362h28.168v73.716c0 10.625 5.792 16.74 15.128 16.74s15.455-6.115 15.455-16.74v-73.716h28.167v74.362c0 25.113-19.797 41.207-43.622 41.207z"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  d: "M272.807 300.245c-8.816 0-15.51-2.975-21.035-8.496-7.967-7.968-7.647-18.592-7.647-29.959 0-11.365-.32-21.99 7.647-29.958 5.525-5.524 12.219-8.496 21.035-8.496 14.341 0 25.919 7.964 28.682 24.646h-18.906c-1.169-4.251-3.507-8.074-9.671-8.074-3.396 0-5.949 1.381-7.327 3.184-1.704 2.233-2.867 4.891-2.867 18.699s1.163 16.467 2.867 18.7c1.378 1.803 3.931 3.181 7.327 3.181 6.165 0 8.502-3.82 9.671-8.072h18.906c-2.762 16.681-14.341 24.645-28.682 24.645z"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M195.781 291.696c-23.821 0-43.296-16.101-43.296-41.207v-74.362h28.168v73.716c0 10.625 5.792 16.74 15.128 16.74s15.455-6.115 15.455-16.74v-73.716h28.171v74.362c0 25.106-19.801 41.207-43.626 41.207z"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M266.378 291.696c-8.822 0-15.51-2.975-21.041-8.499-7.961-7.968-7.641-18.592-7.641-29.958 0-11.369-.32-21.991 7.641-29.958 5.531-5.525 12.218-8.497 21.041-8.497 14.341 0 25.919 7.968 28.682 24.64h-18.906c-1.175-4.245-3.513-8.071-9.671-8.071-3.396 0-5.949 1.381-7.327 3.187-1.704 2.23-2.873 4.885-2.873 18.7 0 13.809 1.169 16.466 2.873 18.693 1.378 1.809 3.932 3.187 7.327 3.187 6.159 0 8.496-3.823 9.671-8.071h18.906c-2.763 16.68-14.341 24.647-28.682 24.647z"
});

function SvgRatingUc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 433.792 347.035"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174);
}

export default SvgRatingUc;